import { render, staticRenderFns } from "./PoiList.vue?vue&type=template&id=4a692330&scoped=true"
import script from "./PoiList.vue?vue&type=script&lang=js"
export * from "./PoiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a692330",
  null
  
)

export default component.exports